import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "hiddenField"];

  updateHiddenField() {
    this.hiddenFieldTarget.value = this.checkboxTarget.checked ? "1" : "0";
    this.hiddenFieldTarget.dispatchEvent(new Event("change"));
  }

  updateCheckbox() {
    this.checkboxTarget.checked =
      this.hiddenFieldTarget.value === "1" ||
      this.hiddenFieldTarget.value === "true";
  }
}
